import React from 'react';
import { ThemeProvider } from 'styled-components';
import { observer } from 'mobx-react-lite';

import { useStore } from '@src/models';

import { DesktopPublicHeader } from '@src/features/common';
import { Tabs, Filters, FiltersWrapper } from '@src/features/feed';
import { useSearchFilter } from '@src/hooks/useSearchFilter';
import { candidateTheme } from 'src/theme';
import { Input } from 'src/kit';
import { MainLayout } from './MainLayout';
import { ROUTES } from 'src/constants';
import FloatingButton from 'src/kit/FloatingButton';

interface PublicFeedProps {
  content: React.ReactNode;
  generateFilters: (store: any) => any;
  activeIndex: number;
  store: string;
  header?: React.ReactNode;
  [key: string]: any;
}

export const PublicFeed = observer(
  ({
    content,
    generateFilters,
    activeIndex,
    store,
    header = <DesktopPublicHeader />,
    marginTop,
    ...props
  }: PublicFeedProps) => {
    const [searchText, setSearchText] = useSearchFilter();
    const { authStore } = useStore();

    console.log('[🏗 PublicFeed] Rendering. store =', store, 'activeIndex =', activeIndex);

    const isEmployerNav = header?.type?.name === 'EmployerNav';
    const margintop = marginTop || (isEmployerNav ? '75px' : undefined);

    return (
      <ThemeProvider theme={candidateTheme}>
        <MainLayout
          subnav={
            <FiltersWrapper minWidth="180px">
              <Tabs activeIndex={activeIndex} />
              <Input
                mt={10}
                value={searchText}
                onChange={e => {
                  e.persist();
                  setSearchText(e.target.value);
                }}
                data-testid="search_input"
              />
              <Filters generateFilters={generateFilters} storeName="feed" />
            </FiltersWrapper>
          }
          header={header}
          sidebar={false}
          footer={null}
          maxWidth={1200}
          bg="white"
          contentStyledProps={{ mx: 0, flex: '1 1 866px', maxWidth: '1600px' }}
          p={{ xs: '30px 10px 70px 10px', xl: '30px 60px 70px 60px' }}
          justifyContent={{ xs: 'flex-start', lg: 'center' }}
          flexWrap={{ xs: 'wrap', lg: 'nowrap' }}
          marginTop={margintop}
          {...props}
        >
          {content}
        </MainLayout>
        {!authStore.isAuthorized && (
          <FloatingButton as="a" href={ROUTES.signUpEmployer} position="bottomRight" size="lg" round>
            Contact us
          </FloatingButton>
        )}
      </ThemeProvider>
    );
  }
);
